angular.module('cfn').filter('userSettingsModel', [
  'templatingService',
  'userSettingsService',
  function(templatingService, userSettingsService) {
    'use strict';

    var getUserSettings = function(settingsKey) {
      return userSettingsService['get' + settingsKey]();
    };

    /* Used in template replacements */
    var handlers = {
      UserSettings: function(settingsKey) {
        return getUserSettings(settingsKey);
      }
    };

    return function(userSettingsKey) {
      if (templatingService.isTemplate(userSettingsKey)) {
        return templatingService.render(userSettingsKey, handlers);
      } else {
        return getUserSettings(userSettingsKey);
      }
    };
  }
]);
